import React, { useEffect } from "react";
import useEvents from "./hooks/useEvents";
import EventSingle from "./SingleEvent";
import "./style.scss";
import { useTranslation } from "react-i18next";
import useFacility from "../../../utils/hooks/useFacility";
import { useSelector } from "react-redux";
import { State } from "../../store";
import EAPageHeader from "../shared/EAPageHeader";
import EAPageMessage from "../shared/EAPageMessage";
import EAAlert from "../shared/EAAlert";
import EASkeletonLoader from "../shared/EASkeletonLoader";

const EventSale: React.FC = () => {
  const { t } = useTranslation();
  const { getEventExercises, exercise, loading } = useEvents();
  const facilityIds = useFacility();
  const saleConfiguration = useSelector((state: State) => state.config.configuration);

  useEffect(() => {
    getEventExercises();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityIds]);

  return (
    <>
      <EAPageHeader componentId="EventSaleActive" />
      <EAPageMessage message={saleConfiguration.message_events} />

      <div className="event-sale-wrapper">
        {loading ? (
          <EASkeletonLoader height="200px" />
        ) : (
          <>
            {exercise.length > 0 ? (
              <>
                {exercise.map((item, index) => (
                  <EventSingle item={item} key={index} />
                ))}
              </>
            ) : (
              <EAAlert type="warning" message={t("aktualnie_brak_nadchodzacych_wydarzen")} />
            )}
          </>
        )}
      </div>
    </>
  );
};

export default EventSale;
